export { useApplePayAvailability } from './useApplePayAvailability.hook';
